<template>
  <div class="center C888">
    <p class="mt80 bold Con opacity5" style="font-size:140px">404</p>
    无此页面
  </div>
</template>

<script>
export default {
  name: 'demo',
  data () {
    return {
      list: []
    }
  },
  components: {
  },
  methods: {
    next () {}
  },
  mounted () {}
}
</script>

<style lang="scss">
</style>
